module.exports = __webpack_public_path__ + "static/img/SAM-CUMMING.8b0002c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SAM-CUMMING.jpg
// module id = exyz
// module chunks = 0